// Local Host Setup

// import axios from "axios";
// export const http = axios.create({ baseURL: "http://localhost:5003/" });
// export const barcode = "http://localhost:5003/images/barcodes/";
// export const server = "http://localhost:5003/";
// export const serverSocket = "http://localhost:5003/";
// export const apiUrlPatients = "http://localhost:5003/prijem/pacijenti/";
// export const apiUrlObradaPregled = "http://localhost:5003/obrada/pregled/";
// export const apiUrlNalaziPregled = "http://localhost:5003/nalazi/pregled";
// export const apiUrlNalaziOutbox = "http://localhost:5003/nalazi/outbox";
// export const apiUrlLabAssays = "http://localhost:5003/assays/lab";
// export const apiUrlAnaAssays = "http://localhost:5003/assays/ana";
// export const apiUrlControlClone = "http://localhost:5003/control/clone";
// export const apiUrlControlEdit = "http://localhost:5003/control/edit";
// export const apiUrlControlResults = "http://localhost:5003/control/results";
// export const apiUrlIntegration = "http://localhost:5003/api/pregled";
// export const apiUrlProdukt = "http://localhost:5003/inventar/produkti";
// export const apiUrlUgovor = "http://localhost:5003/inventar/ugovori";
// export const apiUrlStanje = "http://localhost:5003/inventar/stanje";
// export const apiUrlNarudzbenica = "http://localhost:5003/inventar/narudzbenice";
// export const apiUrlUlaz = "http://localhost:5003/inventar/ulazpregled";
// export const apiUrlIzlaz = "http://localhost:5003/inventar/izlazpregled";

// Client Setup - BH Telecom

import axios from "axios";
export const http = axios.create({ baseURL: "https://labos.ilab.ba/" });
export const barcode = "https://labos.ilab.ba/images/barcodes/";
export const server = "https://labos.ilab.ba/";
export const serverSocket = "https://labos.ilab.ba/";
export const apiUrlPatients = "https://labos.ilab.ba/prijem/pacijenti/";
export const apiUrlObradaPregled = "https://labos.ilab.ba/obrada/pregled/";
export const apiUrlNalaziPregled = "https://labos.ilab.ba/nalazi/pregled";
export const apiUrlNalaziOutbox = "https://labos.ilab.ba/nalazi/outbox";
export const apiUrlLabAssays = "https://labos.ilab.ba/assays/lab";
export const apiUrlAnaAssays = "https://labos.ilab.ba/assays/ana";
export const apiUrlControlClone = "https://labos.ilab.ba/control/clone";
export const apiUrlControlEdit = "https://labos.ilab.ba/control/edit";
export const apiUrlControlResults = "https://labos.ilab.ba/control/results";
export const apiUrlIntegration = "https://labos.ilab.ba/api/pregled";
export const apiUrlProdukt = "https://labos.ilab.ba/inventar/produkti";
export const apiUrlUgovor = "https://labos.ilab.ba/inventar/ugovori";
export const apiUrlStanje = "https://labos.ilab.ba/inventar/stanje";
export const apiUrlNarudzbenica = "https://labos.ilab.ba/inventar/narudzbenice";
export const apiUrlUlaz = "https://labos.ilab.ba/inventar/ulazpregled";
export const apiUrlIzlaz = "https://labos.ilab.ba/inventar/izlazpregled";


//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 116